import { connect } from 'react-redux'
import StudentListOfData from 'modules/Reports/Partials/Students/Partials/ListOfStudentTable/index'
import {
  getStudentListForReport,
  getCollegeList,
  getCourseList,
  getDegreeList,
  getSpecialisationList,
  getCorporateNameList,
  UniversityUrl,
  CollegeUrl,
  DegreeUrl,
  StateUrl,
  StudentCityUrl,
} from 'modules/Reports/Partials/Students/actions'

import selectors from 'modules/Reports/Partials/Students/selectors'
import {getUserInfo } from '../../../../Auth/actions'
import selector from '../../../../Auth/selectors'



const mapStateToProps = state => ({
  studentListDataForReport: selectors?.studentListReportData(state),
  collegeList: selectors?.CollegeListData(state),
  courseList: selectors?.courseListData(state),
  degreeList: selectors?.degreeListData(state),
  specialisationList: selectors?.specialisationListData(state),
  corporateNameList: selectors?.corporateNameList(state),
  excelDataForReport: selectors?.excelData(state),
  universityData: selectors?.universityData(state),
  collegeData: selectors?.collegeData(state),
  degreeData: selectors?.degreeData(state),
  studentStateData: selectors?.stateDatas(state),
  studentCityData: selectors?.cityDatas(state),
  userData: selector?.getUserData(state),

})

const mapDispatchToProps = {
  getStudentListForReport,
  getCollegeList,
  getCourseList,
  getDegreeList,
  getSpecialisationList,
  getCorporateNameList,
  UniversityUrl,
  CollegeUrl,
  DegreeUrl,
  StudentCityUrl,
  StateUrl,
  getUserInfo
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentListOfData)
